// import from 'bootstrap'
import {
  Modal,
  Offcanvas,
  Tab,
  Popover,
  Dropdown,
  Toast,
  Collapse,
  ScrollSpy,
  Button,
  Alert,
} from "bootstrap";

import SwiperInit from "../../js/swiper-init.js";
import AccordionScrollInit from "../../js/accordion-scroll.js";
import PhotoswipeInit from "../../js/photoswipe-init.js";

// import custom SCSS
import "./main.scss";

SwiperInit();
AccordionScrollInit();
PhotoswipeInit();
